import React from 'react'
import { Button, Stack, Typography } from '../../../imports/muiImport';
import { useNavigate } from 'react-router-dom';

const MobileSectionTitle = (props) => {
    const { sectionTitle, buttonText, customBtnHandler, redirectLink } = props;
    const navigate = useNavigate();

    const btnFn = (url) => {
        if (url?.length) {
            navigate(url, { replace: true })
        }
        return;
    }

    return (
        <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"flex-end"}
            marginBottom={0.5}
        >
            {sectionTitle && (
                <Typography
                    variant='subtitle1'
                    sx={{
                        display: "inline-flex",
                        color: "dark.main",
                        fontSize: 16,
                        textTransform: "capitalize",
                        lineHeight: 1,
                        fontWeight: 500
                    }}
                >
                    {sectionTitle}
                </Typography>)}

            {buttonText && (customBtnHandler && !redirectLink ?
                (
                    <Button variant='text'
                        onClick={customBtnHandler}
                        sx={{
                            p: 0,
                            height: 25,

                            color: "dark.main",
                            textTransform: "capitalize",
                            fontWeight: 400,
                            fontSize: "13.5px",
                        }}>
                        {buttonText || "view all"}
                    </Button>)
                :
                (
                    <Button variant='text'
                        onClick={() => btnFn(redirectLink)}
                        sx={{
                            p: 0,
                            width: 80,
                            height: 25,

                            color: "dark.main",
                            textTransform: "capitalize",
                            fontWeight: 500,
                            fontSize: "12.5px",
                        }}>
                        {buttonText || "view all"}
                    </Button>
                ))
            }
        </Stack>
    )
}

export default MobileSectionTitle